import { SpinBoundaryEndActionHandler, type ReplayPlugin } from "@slot/client-engine";
import type { WinSequencePresenter } from "./WinSequencePresenter";

/**
 * A win that stays on the grid (decision 65): the spin's wins start their idle re-show at the spin's end, after the
 * auto-advance hold (the next auto-advanced spin then stops it at once); at a feature's exit, before its finished
 * panel, the re-show stops and the title clears what the session's last spin left (slot-bloody-teddy: the win, its
 * strokes, its battle boards), so a free spin's win never stays in the base game. Listed after the auto-advance hold
 * and before the finished panel.
 */
export function createWinCyclePlugin(deps: {
  presenter: WinSequencePresenter;
  /** The title's clear of a standing win at a feature's exit; absent: only the re-show stops. */
  clearStandingWin?: () => void;
}): ReplayPlugin {
  return {
    name: "win-cycle",
    actionHandlers: [
      new SpinBoundaryEndActionHandler(async () => {
        deps.presenter.startWinCycle();
      }),
    ],
    observer: {
      onFeatureState: async (event) => {
        if (event.eventContent.featureState?.featurePhase !== "exit") return;
        deps.presenter.stopWinCycle();
        deps.clearStandingWin?.();
      },
    },
  };
}
